<template>
  <div>
    <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
        <template #topBtn>
          <el-button type="primary" size="small" @click="handleExport">{{$t('button.orderExport')}}</el-button>
        </template>
      </search-form>
      <create-table :operationColWidth="180" :autoWidth="true" @handleNewTab="handleNewTab($event, 'ordersManagerDeliveryOrdersDetail')" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick" :pageVisible="true" :pageData="pageData" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort" @forwardToPage="forwardToPage">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <!-- <dropListCollect :dropDisabled="selectionData.length < 1" :dropDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></dropListCollect> -->
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item, scope.row)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view />
    <dialogEffect :dateArray="dateArray" :opereteDate="true" v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import { getDeliveryOrderSetup, getDeliveryOrderQueryList, getDeliveryOrderExport } from '@/services/order'
// import _ from 'lodash'
// import loading from '@/utils/loading.json'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import Utils from '@/utils/Utils'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem
    }
  },
  watch: {
    $route (to, from) {
      if (from.name === 'managerDeliveryOrdersView') {
        this.$nextTick(() => {
          this.search()
          this.$refs.createTable.$refs.table.doLayout()
        })
      }
    }
  },
  created () {
    if (this.appName.includes('wholesale')) {
      this.searchExcludes.push('Delivery Zone')
      this.searchExcludes.push({
        name: 'Shipping Method',
        value: 'wholesale'
      }, {
        name: 'Shipping Method',
        value: 'host'
      })
      this.batchExcludes.push('Send SMS')
    }
    this.queryData(getDeliveryOrderSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getDeliveryOrderSetup)
    this.isActive = true
  },
  methods: {
    // queryOpearte () {
    //   console.log(this.searchFormData)
    // },
    // 导出数据接口
    handleExport () {
      this.$refs.searchForm.commonOperate(getDeliveryOrderExport, (data) => {
        this.$router.push({
          name: 'deliveryOrdersDownloadCenter',
          params: { data }
        })
      }, this)
    },
    async forwardToPage (data, name) {
      if (name === 'orders') {
        this.$router.push({
          name: 'ordersManagerUserOrdersDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop') {
        this.$router.push({
          name: 'shopsManagerDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'receiver' && !Utils.isNull(data.id)) {
        this.$router.push({
          name: 'memberDetail',
          params: {
            id: data.id
          }
        })
      }
    },

    // 点击操作按钮
    async handleClick (type, data) {
      this.$router.push({
        name: 'ordersManagerDeliveryOrdersDetail',
        params: {
          id: data.id.value
        }
      })
    },
    // 查询
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getDeliveryOrderQueryList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
</style>
